import React from 'react';

import { ExcludeNil } from '@rbi-ctg/frontend';
import { INavigationTabsFragment } from 'generated/sanity-graphql';

import { SanityNavMobileTab } from './sanity-nav-mobile-tab';
import { NavigationMobileTab } from './types';

export const generateNavigationMobileTabs = (
  sanityTabs: ExcludeNil<INavigationTabsFragment['navigationTabs']>
): NavigationMobileTab[] => {
  return sanityTabs.reduce<NavigationMobileTab[]>((tabs, sanityNavMobileTab) => {
    if (sanityNavMobileTab) {
      tabs.push({
        selectedHrefs: [sanityNavMobileTab?.tabLink?.link?.locale || ''],
        Component: () => <SanityNavMobileTab {...sanityNavMobileTab} />
      });
    }
    return tabs;
  }, []);
};
